import { render, staticRenderFns } from "./TabelaPadrao.vue?vue&type=template&id=1c22f148&"
import script from "./TabelaPadrao.vue?vue&type=script&lang=js&"
export * from "./TabelaPadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports